module.exports = __webpack_public_path__ + "static/media/jcom.552f0dba.webp";